import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function SlackIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_10640_68168)">
        <path
          d="M5.14034 15.118C5.14034 16.4976 4.02538 17.6125 2.64586 17.6125C1.26633 17.6125 0.151367 16.4976 0.151367 15.118C0.151367 13.7385 1.26633 12.6235 2.64586 12.6235H5.14034V15.118ZM6.38759 15.118C6.38759 13.7385 7.50255 12.6235 8.88208 12.6235C10.2616 12.6235 11.3766 13.7385 11.3766 15.118V21.3542C11.3766 22.7338 10.2616 23.8487 8.88208 23.8487C7.50255 23.8487 6.38759 22.7338 6.38759 21.3542V15.118Z"
          fill="#E01E5A"
        />
        <path
          d="M8.88193 5.10226C7.5024 5.10226 6.38744 3.9873 6.38744 2.60777C6.38744 1.22824 7.5024 0.113281 8.88193 0.113281C10.2615 0.113281 11.3764 1.22824 11.3764 2.60777V5.10226H8.88193ZM8.88193 6.3684C10.2615 6.3684 11.3764 7.48336 11.3764 8.86289C11.3764 10.2424 10.2615 11.3574 8.88193 11.3574H2.62681C1.24728 11.3574 0.132324 10.2424 0.132324 8.86289C0.132324 7.48336 1.24728 6.3684 2.62681 6.3684H8.88193Z"
          fill="#36C5F0"
        />
        <path
          d="M18.8788 8.86289C18.8788 7.48336 19.9938 6.3684 21.3733 6.3684C22.7528 6.3684 23.8678 7.48336 23.8678 8.86289C23.8678 10.2424 22.7528 11.3574 21.3733 11.3574H18.8788V8.86289ZM17.6316 8.86289C17.6316 10.2424 16.5166 11.3574 15.1371 11.3574C13.7575 11.3574 12.6426 10.2424 12.6426 8.86289V2.60777C12.6426 1.22824 13.7575 0.113281 15.1371 0.113281C16.5166 0.113281 17.6316 1.22824 17.6316 2.60777V8.86289Z"
          fill="#2EB67D"
        />
        <path
          d="M15.1371 18.8598C16.5166 18.8598 17.6316 19.9747 17.6316 21.3542C17.6316 22.7338 16.5166 23.8487 15.1371 23.8487C13.7575 23.8487 12.6426 22.7338 12.6426 21.3542V18.8598H15.1371ZM15.1371 17.6125C13.7575 17.6125 12.6426 16.4976 12.6426 15.118C12.6426 13.7385 13.7575 12.6235 15.1371 12.6235H21.3922C22.7717 12.6235 23.8867 13.7385 23.8867 15.118C23.8867 16.4976 22.7717 17.6125 21.3922 17.6125H15.1371Z"
          fill="#ECB22E"
        />
      </g>
      <defs>
        <clipPath id="clip0_10640_68168">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
